import { appEventGTag } from "../event";

import { ROUTE, ROUTE_GA_EVENT_PAGE } from "../../misc";

export const event = (pathname: string) => {
    const routeKey = Object.keys(ROUTE).find(key => {
        return ROUTE[key] === pathname;
    });

    appEventGTag({
        page: ROUTE_GA_EVENT_PAGE[routeKey] ?? "home",

        eventName: "click",
        eventLocationType: "button",
        eventLocationLabel: "Queensland logo",
        eventLabel: "Queensland logo is clicked"
    });
};
